import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <SEO 
        title="Terms of Service - LXDIA | Influencer Marketing Agency"
        description="Terms of Service for LXDIA's influencer marketing, talent management, PR, and performance marketing services. Read our service terms and conditions."
        keywords="LXDIA terms, terms of service, influencer marketing terms, agency terms and conditions"
        canonical="https://lxdia.com/terms"
      />
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center text-gray-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
        <p className="text-gray-400 mb-12">Last updated: November 8, 2025</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Agreement to Terms</h2>
            <p className="mb-4">
              By accessing or using LXDIA's services, you agree to be bound by these Terms of Service. 
              If you disagree with any part of these terms, you may not access our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Services Description</h2>
            <p className="mb-4">
              LXDIA provides influencer marketing, talent management, public relations, and performance 
              marketing services. We reserve the right to modify, suspend, or discontinue any service 
              at any time without notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. User Obligations</h2>
            <p className="mb-4">You agree to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Not misuse our services or interfere with their operation</li>
              <li>Not engage in fraudulent or illegal activities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Intellectual Property</h2>
            <p className="mb-4">
              All content, trademarks, and data on this website, including but not limited to software, 
              databases, text, graphics, icons, and hyperlinks, are the property of or licensed to LXDIA 
              and are protected by applicable intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Payment Terms</h2>
            <p className="mb-4">
              Payment terms for services will be specified in individual service agreements. All fees 
              are non-refundable unless otherwise stated in writing. Late payments may incur additional 
              charges and may result in suspension of services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Confidentiality</h2>
            <p className="mb-4">
              Both parties agree to maintain confidentiality of all proprietary information shared during 
              the course of our business relationship. This includes campaign strategies, client data, 
              and business methodologies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Limitation of Liability</h2>
            <p className="mb-4">
              LXDIA shall not be liable for any indirect, incidental, special, consequential, or punitive 
              damages resulting from your use of our services. Our total liability shall not exceed the 
              amount paid by you for the specific service giving rise to the claim.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Termination</h2>
            <p className="mb-4">
              We reserve the right to terminate or suspend access to our services immediately, without 
              prior notice or liability, for any reason, including breach of these Terms of Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Changes to Terms</h2>
            <p className="mb-4">
              We reserve the right to modify these terms at any time. We will notify users of any material 
              changes via email or through our website. Continued use of our services after changes 
              constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Governing Law</h2>
            <p className="mb-4">
              These Terms shall be governed by and construed in accordance with the laws of India. 
              Any disputes arising from these terms shall be subject to the exclusive jurisdiction 
              of the courts in Mumbai, India.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Contact Information</h2>
            <p className="mb-4">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <p className="mb-2">Email: collab@lxdia.com</p>
            <p>Location: Mumbai, India</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
